import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { FaBurn } from "react-icons/fa";
import ReactLoading from 'react-loading';

import "../css/login.css";

export default function Login() {

    const [cookies, setCookie, removeCookie] = useCookies(["userPuuId"]);

    const [ username, setUsername ] = useState("");
    const [ password, setPassword ] = useState("");

    function doLogin(event) {
        event.preventDefault();

        var loadingDiv = document.getElementById("loader");
        loadingDiv.hidden = false;

        axios.post("https://cloudify-backend.herokuapp.com/users/login", {
            "username":username,
            "password":password
        })
        .then(resp => {
            console.log(resp.data);
            if(resp.data.sucesso == true) {
                setCookie("userPuuId", resp.data.userId);
                window.location.href = "/";
            }
            else {
                document.getElementById("errorDiv").hidden = false;
            }
        })
    }

    return (
        <div className="centered">
            <div className="wrapper fadeInDown">
                <div id="formContent">
                    <h2 className="active"> Sign In </h2>
                    <Link to="/signup"> <h2 className="inactive underlineHover">Sign Up </h2> </Link>

                    <div className="fadeIn first">
                        <img src="https://i.ibb.co/px3GVFk/icon-rounded.png" id="icon" alt="User Icon" />
                    </div>

                    <form onSubmit={doLogin} >
                        <input type="text" id="login" className="fadeIn second" name="login" placeholder="Nome de usuário" onChange={(key) => { setUsername(key.target.value) }} value={username} />
                        <input type="password" id="password" className="fadeIn third" name="login" placeholder="Senha" onChange={(key) => { setPassword(key.target.value) }} value={password} />
                        <input type="submit" className="fadeIn fourth" value="Entrar" id="loginButton" onSubmit={doLogin} />
                    </form>
                    
                    <div className="centered" id="loadingDiv" hidden>
                        <ReactLoading type="spin" color="#d37556" height={50} width={50} hidden id="loader" />
                    </div>

                    <div className="centered">
                        <div id="errorDiv" hidden>
                            <div className="centered">
                                <FaBurn />
                            </div>

                            <div className="centered">
                                <h3>Suas senhas não conferem</h3>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}